export let primaryColor = "#FFB800";
export let secondaryColor = "#FEFEFE";
